import React from "react";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from "../../../shadcn/components/ui/dropdown-menu";
import { Button } from "../../../shadcn/components/ui/button";
import ChevronDownSvg from "../../../icons/ChevronDownSvg";

interface StatusDropdownProps {
  statuses: any;
  selectedStatus: string;
  onSelect: (zone: string) => void;
}

const StatusDropdown: React.FC<StatusDropdownProps> = ({
  statuses,
  selectedStatus,
  onSelect,
}) => (
  <DropdownMenu>
    <DropdownMenuTrigger asChild>
      <Button
        variant="outline"
        className="lg:mr-2 gap-x-1 px-2 sm:px-4 sm:gap-x-2 capitalize rounded-[8px]"
      >
        <div className="font-openSans font-normal text-mobile-body-xsm leading-4 md:text-web-body-md md:leading-4">
          {selectedStatus || "Status"}
        </div>
        <ChevronDownSvg height={14} width={14} />
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent className="bg-white rounded-[8px] ">
      {statuses.map((status: any, index: any) => (
        <DropdownMenuItem
          className="hover:cursor-pointer"
          key={index}
          onClick={() => onSelect(status)}
        >
          {status}
        </DropdownMenuItem>
      ))}
    </DropdownMenuContent>
  </DropdownMenu>
);

export default StatusDropdown;
